import { render, staticRenderFns } from "./gestao-acesso.vue?vue&type=template&id=02f8d045&scoped=true"
import script from "./gestao-acesso.vue?vue&type=script&lang=js"
export * from "./gestao-acesso.vue?vue&type=script&lang=js"
import style0 from "./gestao-acesso.vue?vue&type=style&index=0&id=02f8d045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f8d045",
  null
  
)

export default component.exports